export const RowDragHandleColumnId = 'row-drag-handle'
export const AddColumnId = 'add-column'

/** Check whether a column id is for the leading "row handle" field on the table */
export const isDragDropColumnId = (columnId: string): boolean => {
  return columnId === RowDragHandleColumnId
}

/** Check whether this column id is for the trailing "add column" field on the table */
export const isAddColumnId = (columnId: string): boolean => {
  return columnId === AddColumnId
}
